export class PagesRoutes {
  public static ROUTES = {
    Home: {
      path: "home",
      fullPath: 'home',
    },
  };
}
